import React from 'react';
import { Box } from '@mui/material';
import { Text } from 'src/components/BeaconV2Components/Generic/Text';

const BuilderHeader = () => {
  return (
    <Box display="flex" justifyContent="space-between" alignItems="center">
      <Text variant="h2">Presentation Builder</Text>
    </Box>
  );
};

export default BuilderHeader;
